import React, { useState } from 'react'
import { Client } from '@twilio/conversations'
import axios from 'axios'

import { Box, Spinner } from 'layout'

import { participantsURL } from 'global'
import { getToken } from './token'
import { ScreenChat, ScreenSelectChatRooms, ScreenGetNickname } from './utils'

// Handle all chat flow
export default function Chat () {
  const [nickname, setNickname] = useState()
  const [token, setToken] = useState()
  const [conversation, setConversation] = useState()
  const [loading, setLoading] = useState(false)
  const [messages, setMessages] = useState([])
  const [participants, setParticipants] = useState([])
  const [participantSid, setParticipantSid] = useState(null)

  console.log('conversation', conversation)

  const onAddMessage = m => {
    const obj = { author: m.author, message: m.body, dateCreated: m.dateCreated, index: m.index }
    let newMessages = []
    newMessages.push(obj)
    setMessages(messages => messages.concat(newMessages))
  }

  const onAddParticipant = participant => {
    console.log('adding participant', participant)
    setParticipants(participants => participants.concat([participant]))
  }

  const onRemoveParticipant = participant => {
    console.log('remove participant', participant)
  }

  const onFinishGetNickname = form => {
    try {
      setToken(getToken(form.nickname))
      setNickname(form.nickname)
    } catch (ex) {
      console.log('error getting token', ex)
    }
  }

  const onSelectChatroom = room => {
    setLoading(true)
    const participantsBody = {
      identity: nickname,
      conversationSid: room.Sid
    }

    axios.post(participantsURL, participantsBody).then(resp => {
      let client

      setParticipantSid(resp.data)

      try {
        client = new Client(token)
      } catch (ex) {
        console.log('Error trying to instanciate client with the token', token)
      }

      client
        .getConversationBySid(room.Sid)
        .then(async conversationObj => {
          console.log('setting messageAdded')
          conversationObj.on('messageAdded', onAddMessage)
          conversationObj.on('participantJoined', onAddParticipant)
          conversationObj.on('participantLeft', onRemoveParticipant)
          conversationObj
            .getParticipants()
            .then(participants => {
              setParticipants(participants)
              setConversation(conversationObj)
            })
            .catch(e => {
              console.error('conversation error', e)
            })
          setLoading(false)
        })
        .catch(err => {
          console.log('getConversationByUniqueName', err)
        })
    })
  }

  if (loading) {
    return (
      <Box>
        <Spinner />
      </Box>
    )
  }

  if (!nickname) {
    return <ScreenGetNickname onFinish={onFinishGetNickname} />
  }

  if (!token) {
    return <>Retriving token</>
  }

  if (!conversation) {
    return <ScreenSelectChatRooms onFinish={onSelectChatroom} token={token} onReturn={() => setNickname(null)} />
  }

  return (
    <ScreenChat
      messages={messages}
      deleteBody={{ IdentitySid: participantSid, ConversationSid: conversation.sid }}
      onDisconect={async () => {
        setNickname(null)
        setConversation(null)
        setToken(null)
        setParticipantSid(null)
        setMessages([])
        setParticipants([])
      }}
      participants={participants}
      sendMessageCallback={async message => {
        if (conversation) {
          try {
            await conversation.sendMessage(message)
          } catch (ex) {
            if (ex.toString().includes('User not member of channel')) {
              console.log('User not member of channel')
              setNickname(null)
              setConversation(null)
              setToken(null)
              setParticipantSid(null)
              setMessages([])
              setParticipants([])
            }
          }
        }
      }}
    />
  )
}
